import {
  OBJECT_FIELD_TYPES,
  type PropertiesConfigItemDefinition,
  type PropertiesConfigSubsection,
} from '@blaze-shared/elements-domain';

import { propsConfigHelper as epc } from '../../utils/elements-props-config.helpers';

export const formFieldsField = (
  path: string,
  dataSourcePath?: string,
): PropertiesConfigItemDefinition<'formFields'> => ({
  path,
  inputType: 'formFields',
  label: '',
  inputOptions: {
    dataSourcePath,
    fieldConfig: (index: number) => [
      epc.subsections.subsection(
        `${path}.${index}`,
        '',
        [
          epc.fields.textInput(`${path}.${index}.field`, 'Name'),
          epc.fields.selectFieldFromList(`${path}.${index}.dataType`, 'Type', OBJECT_FIELD_TYPES, {
            showSelection: true,
          }),
        ],
        { hideLabel: true },
      ),
    ],
    fieldConditionsConfig: (
      fieldIndex: number,
      isRestricted: boolean,
    ): PropertiesConfigSubsection[] => {
      return [
        epc.subsections.subsection(
          `${path}.${fieldIndex}.conditions`,
          '',
          [formFieldConditionsField(`${path}.${fieldIndex}.conditions`, isRestricted)],
          { hideLabel: true },
        ),
      ];
    },
  },
});

const formFieldConditionsField = (
  path: string,
  isRestricted: boolean,
): PropertiesConfigItemDefinition<'formFieldConditions'> => ({
  inputType: 'formFieldConditions',
  path,
  label: '',
  inputOptions: { isRestricted },
});
